import React from "react";
import { Item1, Item2, Item3 } from "./Items";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

// Variables d'animations (framer motion)

const imgVariants = {
	hover: {
		scale: 1.1,
		opacity: 1,
		transition: {
			yoyo: 100,
		},
	},
	mask: {
		opacity: 0.6,
	},
};

const containerVariants = {
	hidden: {
		opacity: 0,
		y: 100,
	},
	visible: {
		opacity: 1,
		y: 0,
		transition: {
			type: "tween",
			delay: 0.4,
			duration: 0.4,
		},
	},
	exit: {
		x: " -100vw",
		transition: {
			ease: "easeInOut",
			delay: 0.4,
			duration: 0.4,
		},
	},
};

const Home = () => {
	return (
		<motion.section
			variants={containerVariants}
			initial="hidden"
			animate="visible"
			exit="exit"
			className="container"
		>
			<h2 className="container__title">
				a compilation of resources for web developer{" "}
			</h2>
			<div className="container__links">
				<div className="container__links--part">
					{Item1.map((item, index) => {
						return (
							<Link
								key={index}
								to={item.path}
								className={item.cName}
							>
								<motion.img
									variants={imgVariants}
									initial="mask"
									whileHover="hover"
									src={item.img}
									className={item.cNameImg}
									alt="icon of different category from left to right programming, youtube channel, hosting, learning, community,ide"
								/>
								{item.title}
							</Link>
						);
					})}
				</div>
				<div className="container__links--part">
					{Item2.map((item, index) => {
						return (
							<Link
								key={index}
								to={item.path}
								className={item.cName}
							>
								<motion.img
									variants={imgVariants}
									initial="mask"
									whileHover="hover"
									src={item.img}
									className={item.cNameImg}
									alt="icon of different category from left to right programming, youtube channel, hosting, learning, community,ide"
								/>
								{item.title}
							</Link>
						);
					})}
				</div>
				<div className="container__links--part">
					{Item3.map((item, index) => {
						return (
							<Link
								key={index}
								to={item.path}
								className={item.cName}
							>
								<motion.img
									variants={imgVariants}
									initial="mask"
									whileHover="hover"
									src={item.img}
									className={item.cNameImg}
									alt="icon of different category from left to right programming, youtube channel, hosting, learning, community,ide"
								/>
								{item.title}
							</Link>
						);
					})}
				</div>
			</div>
		</motion.section>
	);
};

export default Home;
